import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["title"];
const _hoisted_2 = ["title"];
const _hoisted_3 = ["title"];
const _hoisted_4 = ["title"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("tr", null, [
        _createCommentVNode(" 대행료 시작(이상) "),
        _createElementVNode("td", {
            title: _ctx.fromAmount,
            class: "ta-e td__from-amount"
        }, _toDisplayString(_ctx.fromAmount), 9 /* TEXT, PROPS */, _hoisted_1),
        _createCommentVNode(" 대행료 종료(이하) "),
        _createElementVNode("td", {
            title: _ctx.toAmount,
            class: "ta-e td__to-amount"
        }, _toDisplayString(_ctx.toAmount), 9 /* TEXT, PROPS */, _hoisted_2),
        _createCommentVNode(" 수수료 정액 "),
        _createElementVNode("td", {
            title: _ctx.fee,
            class: "ta-e td__fee"
        }, _toDisplayString(_ctx.fee), 9 /* TEXT, PROPS */, _hoisted_3),
        _createCommentVNode(" 수수료 정률 "),
        _createElementVNode("td", {
            title: _ctx.$t(`${_ctx.lc}percent`, { percent: _ctx.rate }),
            class: "ta-e td__rate"
        }, _toDisplayString(_ctx.$t(`${_ctx.lc}percent`, { percent: _ctx.rate })), 9 /* TEXT, PROPS */, _hoisted_4)
    ]));
}
